<template>
  <div id="app">
    <div class="the_about_body">
      <!-- <div class="the_about_tite_img_body">
        <img class="the_about_tite_img" src="@/assets/img/about-banner.jpg?v=1.0.0.1" />
      </div> -->
      <waveHeader :bg="'type_1'" pathName="aboutus"></waveHeader>
      <div class="the_about_f3_body">
        <div class="common_body">
          <h2 class="the_about_h2 tc" data-aos="fade-right">会社情報</h2>
          <h5 class="the_about_h5 tc" data-aos="fade-right">About THE</h5>
          <div class="the_about_f3_content_body" data-aos="fade-right">
            <div class="the_about_f3_content_box">
              <div class="the_about_f3_content_title">会社名</div>
              <div class="the_about_f3_content">THEグローバルシステム株式会社（略称：THE）</div>
            </div>
            <div class="the_about_f3_content_box">
              <div class="the_about_f3_content_title">住所</div>
              <div class="the_about_f3_content">〒123-0852 東京都足立区関原2一2一27</div>
            </div>
            <div class="the_about_f3_content_box">
              <div class="the_about_f3_content_title">代表者名</div>
              <div class="the_about_f3_content">代表取締役社長：鄭 邦平（テイ ホウヘイ）</div>
            </div>
            <div class="the_about_f3_content_box">
              <div class="the_about_f3_content_title">電話</div>
              <div class="the_about_f3_content"><a href="tel:03-6432-0234">03-6432-0234</a></div>
            </div>
            <div class="the_about_f3_content_box">
              <div class="the_about_f3_content_title">メール</div>
              <div class="the_about_f3_content"><a href="mailto:support@the.co.jp">support@the.co.jp</a></div>
            </div>
            <div class="the_about_f3_content_box">
              <div class="the_about_f3_content_title">資本金</div>
              <div class="the_about_f3_content">2,000万円</div>
            </div> 
            <div class="the_about_f3_content_box">
              <div class="the_about_f3_content_title">労働者派遣事業番号</div>
              <div class="the_about_f3_content">派13-315435</div>
            </div>
            <div class="the_about_f3_content_box">
              <div class="the_about_f3_content_title">東京都公安委員会</div>
              <div class="the_about_f3_content">第301062215223号</div>
            </div>
            <div class="the_about_f3_content_box">
              <div class="the_about_f3_content_title">設立</div>
              <div class="the_about_f3_content">2015年（平成27年）8月11日</div>
            </div>
            <div class="the_about_f3_content_box">
              <div class="the_about_f3_content_title">主要取引銀行</div>
              <div class="the_about_f3_content">城南信用金庫銀行、三菱東京UFJ銀行</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <commonFooter></commonFooter>
  </div>
</template>

<script>
import waveHeader from '../../../components/waveHeader.vue'
import commonFooter from '../../../components/footer.vue'
export default {
  data() {
    return {}
  },
  components: {
    waveHeader,
    commonFooter
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.the_about_tite_img {
  max-width: 100%;
}
.the_about_tite_img_body {
  padding-top: 80px;
  text-align: center;
  padding-bottom: 30px;
  min-height: calc(100vw * 0.1562);
  max-height: 597px;
}
.the_about_h2 {
  font-size: 22px;
  font-weight: bold;
}
.the_about_h5 {
  font-size: 14px;
}
.the_about_big_title {
  padding-bottom: 40px;
}
.the_about_body {
  padding-bottom: 16px;
}
.the_about_f1_body {
  padding-top: 40px;
  padding-bottom: 0px;
}
.the_about_h3 {
  font-size: 22px;
}
.the_about_f1_content {
  line-height: 32px;
  font-size: 16px;
}
.the_about_f2_body {
  padding: 40px 0;
}
.the_about_f2_ico {
  font-size: 72px;
  color: #367ce4;
}
.the_about_f2_title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
.the_about_f2_content {
  font-size: 14px;
}
.the_about_f2_box {
  padding-left: 100px;
  background-position: center left;
  background-size: 90px;
  background-repeat: no-repeat;
  margin-bottom: 40px;
}
.the_about_f2_box.type_1 {
  background-image: url('../../../assets/img/f3/1.png?v=1.0.0.1');
}
.the_about_f2_box.type_2 {
  background-image: url('../../../assets/img/f3/2.png?v=1.0.0.1');
}
.the_about_f2_box.type_3 {
  background-image: url('../../../assets/img/f3/3.png?v=1.0.0.1');
}
.the_about_f2_box.type_4 {
  background-image: url('../../../assets/img/f3/4.png?v=1.0.0.1');
}
.the_about_f3_body {
  padding: 0px 0;
}
.the_about_f3_content_body {
  padding-top: 30px;
  background-image: url(/static/img/the-about.png?v=1.0.0.1);
  background-repeat: no-repeat;
  background-position: right;
  width: auto;
}
.the_about_f3_content_box {
  margin-right: 840px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e6e6e6;
  margin-bottom: 10px;
}
.the_about_f3_content_box:last-child {
  border-bottom: none;
}
.the_about_f3_content_title {
  font-size: 18px;
  color: #367ce4;
  font-weight: bold;
  padding-bottom: 10px;
}
.the_about_f3_table {
  width: 100%;
  min-width: 600px;
}
.the_about_f3_table td,
.the_about_f3_table th {
  border: 1px solid #ccc;
  text-align: center;
  padding: 8px 5px;
  font-size: 14px;
  line-height: 18px;
}
.the_about_f3_table th {
  background-color: #f8f8f8;
}
@media (max-width: 1280px) {
  .the_about_f3_content_box {
    margin-right: 0px;
  }
  .the_about_f3_content_body {
    background-image: none;
  }
}
@media (max-width: 1352px) {
  .the_about_h3 {
    font-size: 18px;
  }
  .the_about_f1_content {
    line-height: 24px;
    font-size: 14px;
    overflow: auto;
  }
}
@media (max-width: 1400px) {
  .the_about_tite_img_body {
    padding-top: 50px;
  }
}
@media (max-width: 768px) {
  .the_about_f3_body {
    margin-top: 20px;
  }
  .the_about_h2 {
    font-size: 22px;
  }
}
</style>
<style>
.the_about_f1_img_body img {
  max-width: 100%;
  height: auto;
  margin-bottom: 24px;
  border-radius: 10px;
}
.the_about_f1_content_body {
  padding: 16px 0 20px 0;
}
.the_about_f2_content_body:first-child {
  padding: 50px 0 0;
}
.the_about_f2_content_body:last-child {
  padding: 0 0 10px 0;
}
@media (max-width: 1200px) {
  .the_about_f1_content_body {
    padding: 0px 0 40px 0;
  }
}
</style>
